export default "__VITE_ASSET__Dq390k6Q__"